// extracted by mini-css-extract-plugin
export default {"spanTextRed600":"App_spanTextRed600__OzS41","spanTextGreen600":"App_spanTextGreen600__nr+MV","spanTextYellow600":"App_spanTextYellow600__qQilk"};